import { CurrentPage, PaginatorNavButton, PaginatorWrapper } from './styles'
import { useTranslation } from 'react-i18next'
import { ArrowRightIcon, ArrowLeftIcon } from 'components/Icons'

interface IProps {
  currentPage: number,
  totalPages: number,
  onChangePage: (page: number) => void,
  disabled?: boolean
}

const Paginator = (props: IProps) => {
  const { currentPage, totalPages, onChangePage, disabled } = props
  const { t } = useTranslation()

  return (
    <PaginatorWrapper>
      <PaginatorNavButton
        onClick={() => {
          if (currentPage > 1) {
            onChangePage(currentPage - 1)
          }
        }}
        active={currentPage > 1 && !disabled}
      >
        <ArrowLeftIcon />
      </PaginatorNavButton>

      <CurrentPage>
        {currentPage} {t('global.over')} {totalPages}
      </CurrentPage>

      <PaginatorNavButton
        onClick={() => {
          if (currentPage < totalPages) {
            onChangePage(currentPage + 1)
          }
        }}
        active={currentPage < totalPages && !disabled}
      >
        <ArrowRightIcon />
      </PaginatorNavButton>
    </PaginatorWrapper>
  )
}

export default Paginator
